module.exports = __webpack_public_path__ + "img/plus_outline_blue.afe9e4dc.svg";